import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DraggableAlert from './DraggableAlert';

const AlertNotification = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <DraggableAlert />
    </DndProvider>
  );
};

export default AlertNotification;
